import { global } from '../global';
import { paths, pathnames } from '../../paths';

export const privacy = {
  global,
  path: paths.privacy,
  pathname: pathnames[paths.privacy],
  content: {
    sections: [
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
        ]
      },
      {
        type: '',
        elements: [
          {
            type: '',
            data: {

            }
          },
        ]
      },
    ]
  }
};
